//* 화환 내역 페이지 전용 hook
//* 기존 shopOrder.hook.ts의 useShopOrderListAgencyAdminHookHook 대체
//* export 엔드포인트 사용 → 전체 데이터 반환 (프론트에서 클라이언트 필터링/페이지네이션)

import { fetcher, useRecoilQuery } from '@shared/hooks/recoil-query';
import { useAuth } from '@shared/state/hooks/useAuth';

import { flowerStatDataAtom, flowerStatStatusAtom } from './flowerStat.atom';
import { FlowerStatDateType } from './flowerStat.interface';

/**
 * flower-stat export URL 생성
 * exportAll=true → 페이지네이션 없이 전체 데이터 반환
 * @param dateType - 날짜 필터 기준 (purchasedAt: 판매일, coffinOutDate: 발인일)
 */
export const flowerStatExportUrl = (
  bugoRole: string,
  startDate?: string,
  endDate?: string,
  dateType?: FlowerStatDateType,
) => {
  const params = new URLSearchParams();
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  if (dateType) params.set('dateType', dateType);
  return `/${bugoRole}/shop-order/flower-stat/export?${params.toString()}`;
};

/**
 * flower-stat 페이지네이션 URL 생성 (추후 서버사이드 페이지네이션 전환용)
 */
export const flowerStatUrl = (
  bugoRole: string,
  params: {
    startDate?: string;
    endDate?: string;
    dateType?: FlowerStatDateType;
    teamType?: string;
    search?: string;
    page?: number;
    limit?: number;
    sort?: string;
  },
) => {
  const searchParams = new URLSearchParams();
  if (params.startDate) searchParams.set('startDate', params.startDate);
  if (params.endDate) searchParams.set('endDate', params.endDate);
  if (params.dateType) searchParams.set('dateType', params.dateType);
  if (params.teamType) searchParams.set('teamType', params.teamType);
  if (params.search) searchParams.set('search', params.search);
  if (params.page) searchParams.set('page', String(params.page));
  if (params.limit) searchParams.set('limit', String(params.limit));
  if (params.sort) searchParams.set('sort', params.sort);
  return `/${bugoRole}/shop-order/flower-stat?${searchParams.toString()}`;
};

/**
 * Phase 1: export 엔드포인트로 전체 데이터 가져오기
 * - 백엔드에서 flat 변환 + summary 계산
 * - 프론트에서 검색/팀타입필터/날짜필터/페이지네이션 처리
 * @param dateType - 날짜 필터 기준 (purchasedAt: 판매일, coffinOutDate: 발인일)
 */
export const useFlowerStatHook = (
  startDate?: string,
  endDate?: string,
  dateType?: FlowerStatDateType,
) => {
  const { bugoRole } = useAuth();

  useRecoilQuery(
    flowerStatStatusAtom,
    flowerStatDataAtom,
    flowerStatExportUrl(bugoRole(), startDate, endDate, dateType),
    fetcher,
  );
};
